import path from 'path';

export class FlavorHelper {
  private flavor?: string;
  private androidResFolder: string;
  private iOSFlavorName: string;

  constructor(flavor?: string) {
    this.flavor = flavor;

    if (flavor) {
      this.androidResFolder = `android/app/src/${flavor}/res/`;
      this.iOSFlavorName = this.capitalize(flavor);
    } else {
      this.androidResFolder = 'android/app/src/main/res/';
      this.iOSFlavorName = '';
    }
  }

  get flavorName(): string | undefined {
    return this.flavor;
  }

  // Android paths
  get androidMainResFolder(): string {
    return this.androidResFolder;
  }

  get androidDrawableFolder(): string {
    return path.join(this.androidResFolder, 'drawable/');
  }

  get androidDrawableNightFolder(): string {
    return path.join(this.androidResFolder, 'drawable-night/');
  }

  get androidDrawableMdpiFolder(): string {
    return path.join(this.androidResFolder, 'drawable-mdpi/');
  }

  get androidDrawableHdpiFolder(): string {
    return path.join(this.androidResFolder, 'drawable-hdpi/');
  }

  get androidDrawableXhdpiFolder(): string {
    return path.join(this.androidResFolder, 'drawable-xhdpi/');
  }

  get androidDrawableXxhdpiFolder(): string {
    return path.join(this.androidResFolder, 'drawable-xxhdpi/');
  }

  get androidDrawableXxxhdpiFolder(): string {
    return path.join(this.androidResFolder, 'drawable-xxxhdpi/');
  }

  get androidLaunchBackgroundFile(): string {
    return path.join(this.androidDrawableFolder, 'launch_background.xml');
  }

  get androidLaunchDarkBackgroundFile(): string {
    return path.join(this.androidDrawableNightFolder, 'launch_background.xml');
  }

  get androidStylesFile(): string {
    return path.join(this.androidResFolder, 'values/styles.xml');
  }

  get androidStylesNightFile(): string {
    return path.join(this.androidResFolder, 'values-night/styles.xml');
  }

  get androidStylesV31File(): string {
    return path.join(this.androidResFolder, 'values-v31/styles.xml');
  }

  get androidStylesV31NightFile(): string {
    return path.join(this.androidResFolder, 'values-night-v31/styles.xml');
  }

  get androidManifestFile(): string {
    return 'android/app/src/main/AndroidManifest.xml';
  }

  // iOS paths
  get iOSAssetsLaunchImageFolder(): string {
    return `ios/AppName/Images.xcassets/LaunchImage${this.iOSFlavorName}.imageset/`;
  }

  get iOSAssetsBrandingImageFolder(): string {
    return `ios/AppName/Images.xcassets/BrandingImage${this.iOSFlavorName}.imageset/`;
  }

  get iOSLaunchScreenStoryboardFile(): string {
    return `ios/AppName/Base.lproj/${this.iOSLaunchScreenStoryboardName}.storyboard`;
  }

  get iOSLaunchScreenStoryboardName(): string {
    return `LaunchScreen${this.iOSFlavorName}`;
  }

  get iOSInfoPlistFile(): string {
    return 'ios/AppName/Info.plist';
  }

  get iOSAssetsLaunchBackgroundFolder(): string {
    return `ios/AppName/Images.xcassets/LaunchBackground${this.iOSFlavorName}.imageset/`;
  }

  get iOSLaunchImageName(): string {
    return this.iOSFlavorName ? `LaunchImage${this.iOSFlavorName}` : 'LaunchImage';
  }

  get iOSBrandingImageName(): string {
    return this.iOSFlavorName ? `BrandingImage${this.iOSFlavorName}` : 'BrandingImage';
  }

  get iOSLaunchBackgroundName(): string {
    return this.iOSFlavorName ? `LaunchBackground${this.iOSFlavorName}` : 'LaunchBackground';
  }

  // Web paths
  get webIndexFile(): string {
    return 'web/index.html';
  }

  get webSplashFolder(): string {
    return 'web/splash/';
  }

  get webSplashImagesFolder(): string {
    return 'web/splash/img/';
  }

  // Helper methods
  private capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  static isValidFlavorConfigFileName(fileName: string): boolean {
    return /^react-native-splash-[^-]+\.(yaml|yml)$/.test(fileName);
  }

  static getFlavorNameFromFileName(fileName: string): string {
    const match = fileName.match(/^react-native-splash-([^-]+)\.(yaml|yml)$/);
    if (!match) {
      throw new Error(`Invalid flavor config filename: ${fileName}`);
    }
    return match[1];
  }
}
